import { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions } from '@mui/material';
import { useDialogContext } from 'src/components/dialog/DialogContext';
import CEditor from 'src/components/editor/CEditor';
import FormProvider from 'src/components/hook-form';
import { FORM_IDS } from 'src/static/constants';

interface IDocumentEditorProps {
  name: string;
  settingsFormMethods: UseFormReturn<any>;
}

export const DocumentEditor = ({ name, settingsFormMethods }: IDocumentEditorProps) => {
  const { t } = useTranslation();
  const { closeDialog } = useDialogContext();
  const initialContent = settingsFormMethods.getValues(name);
  const [editorContent, setEditorContent] = useState(initialContent);

  const handleSave = async () => {
    await settingsFormMethods.setValue(name, editorContent, {
      shouldValidate: true,
      shouldDirty: true,
    });
    closeDialog(FORM_IDS.SETTINGS_EDITOR);
  };

  const handleCancel = () => {
    closeDialog(FORM_IDS.SETTINGS_EDITOR);
  };

  return (
    <FormProvider methods={settingsFormMethods}>
      <Box className="legal-document-editor">
        <CEditor
          name={name}
          onChangeCallback={(value) => setEditorContent(value)}
          controlled={false}
        />
      </Box>
      <DialogActions>
        <Button onClick={handleCancel} variant="contained" color="error">
          {t('common.button.cancel')}
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {t('common.button.save')}
        </Button>
      </DialogActions>
    </FormProvider>
  );
};
